import { selectData } from "fe-shared/utils/reducerUtils";

import {
  STATE_WEBVIEW,
  STATE_WEBVIEW_IS_INPUT_DISABLED,
  STATE_WEBVIEW_IS_FOCUS,
  STATE_WEBVIEW_IS_SKIP_USER_INPUT,
} from "./default";

export const getWebview = state => selectData(state, STATE_WEBVIEW);
export const getWebviewIsInputDisabled = state =>
  selectData(getWebview(state), STATE_WEBVIEW_IS_INPUT_DISABLED);
export const getWebviewIsFocus = state =>
  selectData(getWebview(state), STATE_WEBVIEW_IS_FOCUS);
export const getIsSkipUserInput = state =>
  selectData(getWebview(state), STATE_WEBVIEW_IS_SKIP_USER_INPUT);
